// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class IndexView extends JQueryView {
  currentSlideIndex: number;

  constructor() {
    super('#step-modal');
    this.currentSlideIndex = 0;
  }

  @on({ event: 'click', selector: '.next-btn' })
  nextSlide() {
    this.updateSlide(this.currentSlideIndex + 1);
  }

  @on({ event: 'click', selector: '.prev-btn' })
  prevSlide() {
    this.updateSlide(this.currentSlideIndex - 1);
  }

  @on({ event: 'click', selector: '.indicator' })
  goToSlide(e: any) {
    const index = $(e.currentTarget).index();
    this.updateSlide(index);
  }

  updateSlide(newIndex: number) {
    const slides = $('.slide');
    const indicators = $('.indicator');

    slides.eq(this.currentSlideIndex).addClass('d-none');
    indicators.eq(this.currentSlideIndex).removeClass('active');

    this.currentSlideIndex = newIndex;

    if (this.currentSlideIndex >= slides.length) {
      $('#step-modal').modal('hide');
      window.location.assign('/company/financial');
      return;
    }

    if (this.currentSlideIndex < 0) {
      this.currentSlideIndex = 0;
      $('#step-modal').modal('hide');
    }

    slides.eq(this.currentSlideIndex).removeClass('d-none');
    indicators.eq(this.currentSlideIndex).addClass('active');
  }
}
